import { VideoService } from './VideoService';
import { VideoServiceBus } from './VideoServiceBus';
import { VideoServicePlayback } from './VideoServicePlayback';

export const CoreVideoService = new VideoService(new VideoServiceBus(document), new VideoServicePlayback());
